import React from 'react';
import {TagsCtx} from 'components/dataProviders/tags';


export default function SmartTagText({tagIDs})
{
    const ctx = React.useContext(TagsCtx);
    const [text, setText] = React.useState("");

    React.useEffect(() => {
        if(ctx.loading) return;
        else
        {
            if(tagIDs.length === 0 || !tagIDs) setText("Sin Etiquetas");
            else setText(tagIDs.map((tagID) => (ctx.data.indexed[tagID] ? ctx.data.indexed[tagID].name : "Etiqueta desconocida")).join(", "));
        }
    }, [ctx, tagIDs]);

    return text;
}